import { createPaymentClient } from '@sloxt/features/payment';
import { useAuthStore } from '@/store';

const PAYMENT_URL =
  import.meta.env.VITE_PAYMENT_SERVICE_URL ||
  'https://v6xq979srb.execute-api.us-east-1.amazonaws.com/payment';

/**
 * Apollo client for the payment-service GraphQL endpoint.
 * Forwards the current Zustand auth token; sends nothing for guest checkouts.
 */
export const paymentClient = createPaymentClient({
  uri: PAYMENT_URL,
  getAuthToken: () => useAuthStore.getState().accessToken,
});
